import { Outlet } from "react-router-dom";

const AgricultureDashboard = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default AgricultureDashboard;
